export default __webpack_public_path__ + "resources/icons/n110-4cf0.png";